import { ReactElement } from 'react'
import { Button, Stack, Typography } from '@mui/material'
import { useEditElementStore } from '@editorStores'
import { useElementTypes, useModelClickListeners, useTypeInteraction } from '@editorHooks'
import AddFoundationForm from '../AddFoundationForm'
import FoundationForm from '../FoundationForm'

const foundationTypeInteraction: ElementTypes[] = ['foundation']

interface Props {
  selectedElement: string | null
  selectElement: (element: string | null) => void
}

const FoundationPanel = ({ selectedElement, selectElement }: Props): ReactElement => {
  const elementTypes = useElementTypes()
  const setActiveElement = useEditElementStore(state => state.setActiveElement)

  useTypeInteraction(foundationTypeInteraction)

  useModelClickListeners(
    event => selectElement(event.object.name),
    [elementTypes],
    !selectedElement,
  )

  const handleUnselect = () => {
    selectElement(null)
    setActiveElement(null)
  }

  return (
    <Stack direction="column" spacing={1} width="100%" p={1}>
      <Stack direction="row" justifyContent="end" spacing={1}>
        <Button
          variant="outlined"
          onClick={handleUnselect}
          size="small"
          fullWidth
          disabled={!selectedElement}
          data-cy="btn-unselect"
        >
          Auswahl aufheben
        </Button>
      </Stack>
      <Typography>Wählen Sie ein Fundament an</Typography>
      <AddFoundationForm onCreated={guid => selectElement(guid)} />
      {selectedElement && (
        <FoundationForm selectedElement={selectedElement} setSelectedElement={selectElement} />
      )}
    </Stack>
  )
}

export default FoundationPanel
